import { createContext, useContext, useSyncExternalStore } from 'react';

export const StoreContext = createContext(null);

/** The repository instance. */
export const useRepo = () => useContext(StoreContext);

/**
 * The nested, tombstone-free projection. Re-renders only when a record changes,
 * because the store hands back the same object until something is written.
 */
export function useData() {
  const repo = useRepo();
  return useSyncExternalStore(repo.subscribe, repo.snapshot, repo.snapshot);
}
